export const AppData = {
    "nodes": [
        {
            "name": "提交节点",
            "label": "提交",
            "shape": "ellipse",
            "type": "start-node",
            "img": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABUCAMAAAArteDzAAAAtFBMVEUAAADp8f/o8v/q8v/w9//q9f/////p8v/o8v/o8f/o8v/o8f/o8f/o8f/p8v/p8v/p8v/p8v/o8v/p8v/p8v/q8//r8f/p9P/r8v/u///r///////p8v/q8//p8v/p8v/o8//p8//o8f8fdP+Ds//h7f+SvP8vfv/a6P/T5P9Lj/8kd//l8P+81v+nyf+Esv9inf/K3/+/1/+yz/+dw/96rf9tpf9Vlv9Civ85hf+ixv+HtP/IEq5LAAAAInRSTlMA8L5eIBgD0fn17OHfycGpo5+emXJsSy8nDwwIr5BRrpFSxMyWqAAAAjNJREFUWMPNmYl22jAQReWdfbMhiw1Jn4qhUCDN0qbt//9XG7I4CdgayZqT3A9452hmNKtQ4k+S2I06rUaj1YncOJn4oh6BN2zjgPbQC0wVzz0XpbjeuYHk6aiJSpqjU03Jkz4I9E90TDkAkQHVuOHYARlnHFI0/S606BJCbOZAE+eL6ulTGHBZaYI0gxFZWq551oMhvbNSzQjGRCWqaQ816KVHfXSBWmTHvDVFTS6PxCdqcxCvvoPaOP47g3Zhge5bs45hhfGbXOfACk4gCgawxOBVnoc1ilrQhzX6LzUOFnmuhiNYZPRU35uwSPOxH/BgFW8v6kLBfJt/Axl3H/hKzZWU67/fQSWgvH4rH1j90Hn/EAp2cs86B43hf9E2FHyVT/yiWbYthA+yqFz8AQVfTAiiBVdLqJmIREtULm6gJBExTbTg5xwKYuHqisrfG2X4R2TRgrvqnxCJjoGoXFX6qyNaJqLyvsqwLdEwEpW3KKdhKppXiRo+f7Gser6ZoxabSkfph5Q6s0T6wa/Oga7+N1Vn61g3oax36rqSaKa++2tS6vN1RO/mIOATysnuJT3dUMuJuvDlz4l0SS98HhRsHuN9q1OiA6i4eihO9B4loLU9t/k1yLgsDRpLK8nR9LK05xyDBMvIwzGcsYyRHAMvy2jOsURgWHfMGBYzU3FImKEWWcix7OJZy/EvEOuvOi9S+0vZaWh/fTzjWHRzrOQZjgcMZ46PP8hQTkef58hlfo77B59Y32y1suSYAAAAAElFTkSuQmCC",
            "id": "start-node1657090334090",
            "size": [
                100,
                50
            ],
            "data": {
                "label": "提交"
            },
            "x": 190,
            "y": 130,
            "anchorPoints": [
                [
                    0.5,
                    0
                ],
                [
                    0,
                    0.5
                ],
                [
                    0.5,
                    1
                ],
                [
                    1,
                    0.5
                ]
            ],
            "style": {
                "fill": "#E8F1FF",
                "lineWidth": 0,
                "stroke": "#1F74FF",
                "cursor": "pointer"
            },
            "labelCfg": {
                "style": {
                    "fontSize": 14,
                    "fill": "#1F74FF",
                    "cursor": "pointer"
                }
            }
        },
        {
            "name": "经办节点",
            "label": "经办2",
            "shape": "hexagon",
            "type": "handle-node",
            "img": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABUCAMAAAArteDzAAAAt1BMVEUAAADp8f/o8f/w9//q9f/u///p8v/o8v/o8f/o8v/o8f/p8v/o8v/o8v/p8v/p8v/p8v/o8v/p8v/p8v/q8//q8v/p8f/r8f/p9P/r8v/1///o8f/q8//p8v/p8v/o8//p8//o8f8fdP+10v+Ds/8hdf+Itv9Wl/9MkP8idv81gv/i7f/A2P+Xv/90qf9inv8nef+Puv+Bsv9Aif/V5f/O4f+20v97rf9qov9Qkv8uff/G3P+00P9jqWt/AAAAIXRSTlMA8OAgGA7R+fXsycG/va+jn56ZcmxgXUsvJwmpkFGqkVJZnjI2AAACh0lEQVRYw82Z6W7iMBSFnQTCvpcdOnMCLWUvS4Eu7/9cEyOkSSHHBOPM9PuFFPmTsa/t62txFadZq+ZdO5NKZWw3X601HXEfiUbZxgV2uZHQNSbrBVAK9aSGsl1JQ0m60r5R2eoiAo+tW4ayhIiUIg/ug4XIWA+RlE4WN5GNEGJ9Czdi/b7m7EGDX0plpwgtih1FuOegSS5JnS60cYm1k8Md5MJHoIi7KGrMu1YM9HE3F/HqWLgb63xtZWGA7NkeAiM8BJ0JC0awgjthCYYoBfZ5GOPvWdCFMR7FiTZCePICDBGZ9klaMSmtnDantElpOikkdZiUoi4kBSp9H/p4px9BVjNQCsfAB5Wu4eOFstmBIRdAg0sPAx8vnPEchIYvLXOpGmYt+1JbV/q6RSi2EA5w++zPJp7PmjR1RFNHik/5+YU0bYoa+bIbBHjDOSP5/0nTmqhCi70MAPKtKvLQYqnoaV640GE29qUTlq0IGwqms0Eo8w/PZwkWUxlFd0bqYP0i7TIiBcZ87ClZgpDi0mfvinNKpfTvv6n7+TEHJUMnaiGbTvbPoay+puDYNKQ2sjtb6ODS4H/1pQtokafLdHzchrSoipqip/vL6RsE2NENpakY0w3OGXoBnujW56hmfzHVkTr0OPn0JJOX70wiSG158NGuUtTSMj+iMT0w2cDnwKUNmkxIVmSlwmfNpQme9ki2q+XoO8cxHfq8U2nhlKBRdEKqTlNJfWk6SZNefWmFp+f60nYMF4luvFce85cz89dI8xde81fzeIoI5ssd/RgKM71/VUIyX+wyX5YzX0A0X+o0FAO9GMrH/ZgK3eZL8uYfD4w/c3Rb//9BJsrT0c955NJ/jvsDPGXOanxAJfMAAAAASUVORK5CYII=",
            "id": "handle-node1657090338034",
            "size": [
                130,
                50
            ],
            "data": {
                "label": "经办2",
                "handleType": 1,
                "remark": "11",
                "handleTypeObj": {
                    "type": 1,
                    "name": "开票人评估"
                }
            },
            "x": 650,
            "y": 95,
            "anchorPoints": [
                [
                    0.5,
                    0
                ],
                [
                    0,
                    0.5
                ],
                [
                    0.5,
                    1
                ],
                [
                    1,
                    0.5
                ]
            ],
            "style": {
                "fill": "#E8F1FF",
                "lineWidth": 0,
                "stroke": "#1F74FF",
                "cursor": "pointer"
            },
            "labelCfg": {
                "style": {
                    "fontSize": 14,
                    "fill": "#1F74FF",
                    "cursor": "pointer"
                }
            }
        },
        {
            "name": "审批节点",
            "label": "审批22",
            "shape": "rect",
            "type": "approval-node",
            "img": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABUCAMAAAArteDzAAAAt1BMVEUAAADp8f/o8f/w9//q9f/u///p8v/o8v/o8f/o8v/o8f/p8v/o8v/o8v/p8v/p8v/p8v/o8v/p8v/p8v/q8//q8v/p8f/r8f/p9P/r8v/1///o8f/q8//p8v/p8v/o8//p8//o8f8fdP+10v+Ds/8hdf+Itv9Wl/9MkP8idv81gv/i7f/A2P+Xv/90qf9inv8nef+Puv+Bsv9Aif/V5f/O4f+20v97rf9qov9Qkv8uff/G3P+00P9jqWt/AAAAIXRSTlMA8OAgGA7R+fXsycG/va+jn56ZcmxgXUsvJwmpkFGqkVJZnjI2AAACh0lEQVRYw82Z6W7iMBSFnQTCvpcdOnMCLWUvS4Eu7/9cEyOkSSHHBOPM9PuFFPmTsa/t62txFadZq+ZdO5NKZWw3X601HXEfiUbZxgV2uZHQNSbrBVAK9aSGsl1JQ0m60r5R2eoiAo+tW4ayhIiUIg/ug4XIWA+RlE4WN5GNEGJ9Czdi/b7m7EGDX0plpwgtih1FuOegSS5JnS60cYm1k8Md5MJHoIi7KGrMu1YM9HE3F/HqWLgb63xtZWGA7NkeAiM8BJ0JC0awgjthCYYoBfZ5GOPvWdCFMR7FiTZCePICDBGZ9klaMSmtnDantElpOikkdZiUoi4kBSp9H/p4px9BVjNQCsfAB5Wu4eOFstmBIRdAg0sPAx8vnPEchIYvLXOpGmYt+1JbV/q6RSi2EA5w++zPJp7PmjR1RFNHik/5+YU0bYoa+bIbBHjDOSP5/0nTmqhCi70MAPKtKvLQYqnoaV640GE29qUTlq0IGwqms0Eo8w/PZwkWUxlFd0bqYP0i7TIiBcZ87ClZgpDi0mfvinNKpfTvv6n7+TEHJUMnaiGbTvbPoay+puDYNKQ2sjtb6ODS4H/1pQtokafLdHzchrSoipqip/vL6RsE2NENpakY0w3OGXoBnujW56hmfzHVkTr0OPn0JJOX70wiSG158NGuUtTSMj+iMT0w2cDnwKUNmkxIVmSlwmfNpQme9ki2q+XoO8cxHfq8U2nhlKBRdEKqTlNJfWk6SZNefWmFp+f60nYMF4luvFce85cz89dI8xde81fzeIoI5ssd/RgKM71/VUIyX+wyX5YzX0A0X+o0FAO9GMrH/ZgK3eZL8uYfD4w/c3Rb//9BJsrT0c955NJ/jvsDPGXOanxAJfMAAAAASUVORK5CYII=",
            "id": "approval-node1657090342243",
            "size": [
                130,
                40
            ],
            "data": {
                "label": "审批22",
                "approvalData": [
                    {
                        "type": "staff",
                        "typeName": "员工",
                        "approvalValue": [
                            4,
                            5
                        ]
                    },
                    {
                        "type": "station",
                        "typeName": "角色",
                        "approvalValue": [
                            1,
                            2
                        ]
                    }
                ],
                "checkMethod": 1,
                "checkRepeat": 1,
                "checkElement": "12321321",
                "remark": "23213",
                "chosenObj": {
                    "staff": [
                        {
                            "id": 4,
                            "name": "瞿敏霞"
                        },
                        {
                            "id": 5,
                            "name": "吴严"
                        }
                    ],
                    "station": [
                        {
                            "id": 1,
                            "name": "外贸顾问"
                        },
                        {
                            "id": 2,
                            "name": "增值客服"
                        }
                    ]
                }
            },
            "x": 635,
            "y": 215,
            "anchorPoints": [
                [
                    0.5,
                    0
                ],
                [
                    0,
                    0.5
                ],
                [
                    0.5,
                    1
                ],
                [
                    1,
                    0.5
                ]
            ],
            "style": {
                "fill": "#E8F1FF",
                "lineWidth": 0,
                "stroke": "#1F74FF",
                "cursor": "pointer"
            },
            "labelCfg": {
                "style": {
                    "fontSize": 14,
                    "fill": "#1F74FF",
                    "cursor": "pointer"
                }
            }
        },
        {
            "name": "经办节点",
            "label": "经办1",
            "shape": "hexagon",
            "type": "handle-node",
            "img": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABUCAMAAAArteDzAAAAt1BMVEUAAADp8f/o8f/w9//q9f/u///p8v/o8v/o8f/o8v/o8f/p8v/o8v/o8v/p8v/p8v/p8v/o8v/p8v/p8v/q8//q8v/p8f/r8f/p9P/r8v/1///o8f/q8//p8v/p8v/o8//p8//o8f8fdP+10v+Ds/8hdf+Itv9Wl/9MkP8idv81gv/i7f/A2P+Xv/90qf9inv8nef+Puv+Bsv9Aif/V5f/O4f+20v97rf9qov9Qkv8uff/G3P+00P9jqWt/AAAAIXRSTlMA8OAgGA7R+fXsycG/va+jn56ZcmxgXUsvJwmpkFGqkVJZnjI2AAACh0lEQVRYw82Z6W7iMBSFnQTCvpcdOnMCLWUvS4Eu7/9cEyOkSSHHBOPM9PuFFPmTsa/t62txFadZq+ZdO5NKZWw3X601HXEfiUbZxgV2uZHQNSbrBVAK9aSGsl1JQ0m60r5R2eoiAo+tW4ayhIiUIg/ug4XIWA+RlE4WN5GNEGJ9Czdi/b7m7EGDX0plpwgtih1FuOegSS5JnS60cYm1k8Md5MJHoIi7KGrMu1YM9HE3F/HqWLgb63xtZWGA7NkeAiM8BJ0JC0awgjthCYYoBfZ5GOPvWdCFMR7FiTZCePICDBGZ9klaMSmtnDantElpOikkdZiUoi4kBSp9H/p4px9BVjNQCsfAB5Wu4eOFstmBIRdAg0sPAx8vnPEchIYvLXOpGmYt+1JbV/q6RSi2EA5w++zPJp7PmjR1RFNHik/5+YU0bYoa+bIbBHjDOSP5/0nTmqhCi70MAPKtKvLQYqnoaV640GE29qUTlq0IGwqms0Eo8w/PZwkWUxlFd0bqYP0i7TIiBcZ87ClZgpDi0mfvinNKpfTvv6n7+TEHJUMnaiGbTvbPoay+puDYNKQ2sjtb6ODS4H/1pQtokafLdHzchrSoipqip/vL6RsE2NENpakY0w3OGXoBnujW56hmfzHVkTr0OPn0JJOX70wiSG158NGuUtTSMj+iMT0w2cDnwKUNmkxIVmSlwmfNpQme9ki2q+XoO8cxHfq8U2nhlKBRdEKqTlNJfWk6SZNefWmFp+f60nYMF4luvFce85cz89dI8xde81fzeIoI5ssd/RgKM71/VUIyX+wyX5YzX0A0X+o0FAO9GMrH/ZgK3eZL8uYfD4w/c3Rb//9BJsrT0c955NJ/jvsDPGXOanxAJfMAAAAASUVORK5CYII=",
            "id": "handle-node1657090345354",
            "size": [
                130,
                50
            ],
            "data": {
                "label": "经办1",
                "remark": "ttre",
                "handleType": 1,
                "handleTypeObj": {
                    "type": 1,
                    "name": "开票人评估"
                }
            },
            "x": 930,
            "y": 160,
            "anchorPoints": [
                [
                    0.5,
                    0
                ],
                [
                    0,
                    0.5
                ],
                [
                    0.5,
                    1
                ],
                [
                    1,
                    0.5
                ]
            ],
            "style": {
                "fill": "#E8F1FF",
                "lineWidth": 0,
                "stroke": "#1F74FF",
                "cursor": "pointer"
            },
            "labelCfg": {
                "style": {
                    "fontSize": 14,
                    "fill": "#1F74FF",
                    "cursor": "pointer"
                }
            }
        },
        {
            "name": "结束节点",
            "label": "结束",
            "shape": "ellipse",
            "type": "end-node",
            "img": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABUCAMAAAArteDzAAAA0lBMVEUAAADp8f/o8f/o8v/p8v/q8v/q9f/t///////o8v/o8f/o8v/p8v/o8f/p8v/p8v/p8v/p8v/p8v/p8v/q8//r8f/p9P/r8v/w9//v9//////q8//p8v/p8f/o8//p8//o8f8fdP9Nkf/j7v9Rk//J3v9loP87hv8ygP/a6f+Qu//f6/+y0P+tzP92qv9ZmP8jd//T5P/O4f/D2v+bwv+TvP+Itf9tpf9Div8rfP8mef+81v9Kjv82g//R4/+lx/+Zv/+Nuf/W5v+fxP+AsP97rv+s0GUSAAAAIHRSTlMA8OC+n14YDQP59ezSycGvqaOZcmxLLychIAiQUc+RUuJJzjgAAANbSURBVFjDzZnZduIwDIaTQGgpW8vSsrQdqSFsAcq+073v/0rDURgmKZYTEmDmu+MY/Se2ZMmWFU9KhVw2ktQS8XhCS0ayuUJJCUdMj2qwhxbVY0EVL/QIsET0iwCSd9ErkHIVvTtQ8vYafHB9e8hS3oBPbvwu7mVeBd+o+Us/msUUHESq6K15r8KBqL+8pl6BADxKl6CcgUBkypJwT0NA0hes5gME5oFRLachBOmy0EcZCEVG5K0KhORREJ8Qmr14LaoQGrX4Y0FTcARS7mXNw1HIu3KdCkdBdWZCH/lz0mhMfORXR54HT0a4YQSe/K0FPmrHM2549lFhdjUOvHnCDU/gzZ9qGD2maHSbnGS1uNncEzU/l7LKbacrHViMKWLNcouOEXEKPDqJRnhNcs+XS9RakMsM/uxCgc8OW1UkKZeoiUTVAo6YbPbWComaS9RoIPFksPOX+X6KRGPgXtPlHImJzP8aM/a61TR/en9of2tvyBhqilLinLQm0/pgP04HdRqacQtQUgrMSIsM5y+i4DcXNNhiTAtKjhmZkd2beEe17FkwpjklKx4Y2oHDbVP6iR0QkuVC/5us2pxoh4anXPgnxQNr8jxwosbcHheSZCKqT1/SZUWhS3/oMzGVABH29F5hR9W9xPApWdSEEgcRb2SzdH6Z+8uX2+AQEWdE38nmxZFXZ4izJuwY0B/exaLM9Cdk4xABo902nMlbsv8TjKNGZGMCi4l8edWUpMRRbWBpS/6QZIJ/6Nzc/KIPxcHPbFOrRyHkUV17FrNNc5LDQ68JDB8oOVzkuNQ3JqtvYOhKwhQKXJJ+IatFXzw66NHwB5Ok2XJSk02wuq2IQjS+8Jn2x3zxk+8N+MKny4vpO7fdsCsp0THOwQ0kpga4MGpIrLnQiMmOPcsFEvWOq3LXkVgM+WOPZP6UM4nVuL+NidYKt7wCg+5xlGzhjnq1VqvWcceYP0p6HXo7cxQy51NN1Pt4bs5EmjNTejz3vkiM1j8l1yPgufZ35THIOTtWLUN65fF9OeuPN05azDfOojCQcHOSa+QpLrwnuZqfoolwgnbH/QkaM5UztZDCN7vO05YL30A8R6szfFO2cnn89vH9eRrd4Vvy53g8CP/M8e8fZPw8Hf0/j1zBn+N+A7rowCv4UEqpAAAAAElFTkSuQmCC",
            "id": "end-node1657090349283",
            "size": [
                100,
                50
            ],
            "data": {
                "label": "结束"
            },
            "x": 660,
            "y": 455,
            "anchorPoints": [
                [
                    0.5,
                    0
                ],
                [
                    0,
                    0.5
                ],
                [
                    0.5,
                    1
                ],
                [
                    1,
                    0.5
                ]
            ],
            "style": {
                "fill": "#E8F1FF",
                "lineWidth": 0,
                "stroke": "#1F74FF",
                "cursor": "pointer"
            },
            "labelCfg": {
                "style": {
                    "fontSize": 14,
                    "fill": "#1F74FF",
                    "cursor": "pointer"
                }
            }
        },
        {
            "name": "判定节点",
            "label": "判定1",
            "shape": "diamond",
            "type": "judge-node",
            "img": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABUCAMAAAArteDzAAAAzFBMVEUAAADp8f/p8v/p8v/q8v/q9f/t///////o8v/o8f/o8v/o8f/o8f/p8v/o8f/o8v/p8v/p8v/p8v/p8v/q8//p8v/q8//r8f/p9P/r8v/w9//v9//////p8v/p8f/p8//o8f8fdP/R4/+/1//f6/9zqf9Vlv9Pkv96rP/C2f+10v9jnv8zgf/i7v+zz/9mof9Civ9tpf8sff8leP/b6f/J3v+ixf+Vvf+Ds/9+sP/X5/+oyv9amf9gnP87hv+LuP94rP9Jj/8qe/+wzv9qj44MAAAAIHRSTlMA8MCfXhgNA/n17OHf0sm9r6mjmZBybEsvJyEgCFHPUveBOXkAAALlSURBVFjDzZnpUiIxFEbTC8i+76Dz0YgtqCO7ooDLvP87zUCUFJB0QnOp8fyhqqk+kNyb7YZpaVbLRTudSsRiiVTaLparTXYaEddJ4oCk40bCGqNuFkqybjSEsu7EEUjcqR+prOVhQL52TFcWYEjBtHMvKhaMsSoXJs5GBkeRaeidlxaOxPqla3oJISgFdkErh1DkWgHpbiMkdlTpvEJorhTWlo0TsFvSGOVwEjlZtEo4kZIkP3EyB/nasHAyVmOvQzMgILPbrRWQUNmZ6yyQYEWYoIAg+t1rGFIQzhqCeG63Vz0YItaCPNR4fvsf4zeYkd+ucVDzOmpzFi8wos44DlQ8dNtb7vswweHOaBwKpgPu++QfcxgQ59OVCwVPY66cvSy51fegx91Is5Ayufs2Cf/oFVqym8SHlM6KO593e6L7AB0RZevf+F9bdbYxe+fWwVTbfkXsX264YXgNwZ/7zbPx0+9vpsr4J8E5fH002/upRXuXLmQkGWtKov6VmJ7sG70UTVaVpPyQv7OcyIasXlplZUiYfcoG0WzEQzVcs1BLy6woH0sfIqG+mDzuJFVfLS0yWzHq3/cGUf9epL9GarN0wPwkLA+34je00jRLBc+kvL29gegNvTTFEoFzPo/M83gvbu++P1g/8H1fMmwTLAYZoiMFC5FhN+KpZPmKBUjFeOWjEzCWJhDMG3931YOxNMFS0NBZd8HjNfalHc8byKUploaOddL3cCD1gA+5NM1seqnNimGli+VyJJcWWdlUah6oMqvSS6usSS9tMpYMIZ12tkiXE+YggMl8Pl9n43A+n8EQhy/RajzRzjsItEt0hFoa4dseUmmWb9Bopa7YStJIxVaSOZRSh3HqlNK6OEiQSfPiyEMnrRkczia3W4xGVOGsx0j6Ay/90Zy+iEBf7rg8e2GGvoREX+yiL8vRFxDpS530RVn68vHluQrd9CV5+ssD+muO/38hY3J19HMuucJfx/0FVTrA4PtaFXEAAAAASUVORK5CYII=",
            "id": "judge-node1657090432441",
            "size": [
                140,
                50
            ],
            "data": {
                "label": "判定1",
                "remark": "123"
            },
            "x": 365,
            "y": 135,
            "anchorPoints": [
                [
                    0.5,
                    0
                ],
                [
                    0,
                    0.5
                ],
                [
                    0.5,
                    1
                ],
                [
                    1,
                    0.5
                ]
            ],
            "style": {
                "fill": "#E8F1FF",
                "lineWidth": 0,
                "stroke": "#1F74FF",
                "cursor": "pointer"
            },
            "labelCfg": {
                "style": {
                    "fontSize": 14,
                    "fill": "#1F74FF",
                    "cursor": "pointer"
                }
            }
        }
    ],
    "edges": [
        {
            "clazz": "flow",
            "source": "handle-node1657090338034",
            "target": "handle-node1657090345354",
            "sourceAnchor": 3,
            "targetAnchor": 1,
            "sourceType": "handle-node",
            "targetType": "handle-node",
            "shape": "flow-polyline-round",
            "style": {
                "stroke": "#BFC5D2",
                "lineWidth": 1,
                "lineAppendWidth": 10,
                "cursor": "pointer"
            },
            "startPoint": {
                "x": 715,
                "y": 95,
                "index": 3
            },
            "endPoint": {
                "x": 865,
                "y": 160,
                "index": 1
            }
        },
        {
            "clazz": "flow",
            "source": "approval-node1657090342243",
            "target": "handle-node1657090345354",
            "sourceAnchor": 3,
            "targetAnchor": 1,
            "sourceType": "approval-node",
            "targetType": "handle-node",
            "shape": "flow-polyline-round",
            "style": {
                "stroke": "#BFC5D2",
                "lineWidth": 1,
                "lineAppendWidth": 10,
                "cursor": "pointer"
            },
            "startPoint": {
                "x": 700,
                "y": 215,
                "index": 3
            },
            "endPoint": {
                "x": 865,
                "y": 160,
                "index": 1
            }
        },
        {
            "clazz": "flow",
            "source": "judge-node1657090432441",
            "target": "handle-node1657090338034",
            "sourceAnchor": 3,
            "targetAnchor": 1,
            "sourceType": "judge-node",
            "targetType": "handle-node",
            "shape": "flow-polyline-round",
            "style": {
                "stroke": "#BFC5D2",
                "lineWidth": 1,
                "lineAppendWidth": 10,
                "cursor": "pointer"
            },
            "startPoint": {
                "x": 435,
                "y": 135,
                "index": 3
            },
            "endPoint": {
                "x": 585,
                "y": 95,
                "index": 1
            },
            "type": "edge",
            "id": "edge7",
            "data": {
                "conditionData": [
                    {
                        "link": null,
                        "leftParenthesis": false,
                        "field": "departId",
                        "condition": "包含于",
                        "compareObj": [
                            2
                        ],
                        "rightParenthesis": false,
                        "judgeCondition": null,
                        "compareOptions": [
                            {
                                "code": "default_org",
                                "name": "默认部门",
                                "id": -1,
                                "text": "默认部门",
                                "sort": 1
                            },
                            {
                                "code": "JSB",
                                "name": "技术部",
                                "id": 2,
                                "text": "枣庄晟智-技术部",
                                "sort": 1
                            },
                            {
                                "code": "JSB01",
                                "name": "测试部",
                                "id": 3,
                                "text": "枣庄晟智-技术部-测试部",
                                "sort": 1
                            },
                            {
                                "code": "YYZX01",
                                "name": "商务组",
                                "id": 5,
                                "text": "枣庄晟智-运营中心-商务组",
                                "sort": 1
                            },
                            {
                                "code": "KFZ01",
                                "name": "客服1号部门",
                                "id": 9,
                                "text": "枣庄晟智-客服组-客服1号部门",
                                "sort": 1
                            },
                            {
                                "code": "KFZ0101",
                                "name": "客服2号部门",
                                "id": 10,
                                "text": "枣庄晟智-客服组-客服1号部门-客服2号部门",
                                "sort": 1
                            },
                            {
                                "code": "YYZX",
                                "name": "运营中心",
                                "id": 4,
                                "text": "枣庄晟智-运营中心",
                                "sort": 2
                            },
                            {
                                "code": "JSB02",
                                "name": "开发组",
                                "id": 6,
                                "text": "枣庄晟智-技术部-开发组",
                                "sort": 2
                            },
                            {
                                "code": "JSB03",
                                "name": "产品设计组",
                                "id": 7,
                                "text": "枣庄晟智-技术部-产品设计组",
                                "sort": 3
                            },
                            {
                                "code": "KFZ",
                                "name": "客服组",
                                "id": 8,
                                "text": "枣庄晟智-客服组",
                                "sort": 4
                            }
                        ],
                        "compareOptionsMulti": true,
                        "paramTypeId": 2,
                        "paramObj": {
                            "createdById": 0,
                            "createdByName": "系统",
                            "createdAt": "2022-02-22 14:10",
                            "lastUpdatedById": 0,
                            "lastUpdatedByName": "系统",
                            "lastUpdatedAt": "2022-02-22 14:10",
                            "deleted": false,
                            "id": 2,
                            "typeId": 1,
                            "typeName": "固定参数",
                            "paramTypeId": 2,
                            "paramTypeName": "字符",
                            "defCode": null,
                            "defName": null,
                            "paramName": "departId",
                            "paramKey": "提交人主部门",
                            "description": null
                        }
                    }
                ],
                "label": "提交人主部门 包含于 技术部",
                "expression": "'2'.contains(departId)",
                "previewStr": "提交人主部门 包含于 技术部"
            },
            "label": "提交人主部门 包含于…"
        },
        {
            "clazz": "flow",
            "source": "judge-node1657090432441",
            "target": "handle-node1657090338034",
            "sourceAnchor": 3,
            "targetAnchor": 1,
            "sourceType": "judge-node",
            "targetType": "handle-node",
            "shape": "flow-polyline-round",
            "style": {
                "stroke": "#BFC5D2",
                "lineWidth": 1,
                "lineAppendWidth": 10,
                "cursor": "pointer"
            },
            "startPoint": {
                "x": 435,
                "y": 135,
                "index": 3
            },
            "endPoint": {
                "x": 585,
                "y": 95,
                "index": 1
            },
            "type": "edge",
            "id": "edge7",
            "data": {
                "conditionData": [
                    {
                        "link": null,
                        "leftParenthesis": false,
                        "field": "departId",
                        "condition": "包含于",
                        "compareObj": [
                            2
                        ],
                        "rightParenthesis": false,
                        "judgeCondition": null,
                        "compareOptions": [
                            {
                                "code": "default_org",
                                "name": "默认部门",
                                "id": -1,
                                "text": "默认部门",
                                "sort": 1
                            },
                            {
                                "code": "JSB",
                                "name": "技术部",
                                "id": 2,
                                "text": "枣庄晟智-技术部",
                                "sort": 1
                            },
                            {
                                "code": "JSB01",
                                "name": "测试部",
                                "id": 3,
                                "text": "枣庄晟智-技术部-测试部",
                                "sort": 1
                            },
                            {
                                "code": "YYZX01",
                                "name": "商务组",
                                "id": 5,
                                "text": "枣庄晟智-运营中心-商务组",
                                "sort": 1
                            },
                            {
                                "code": "KFZ01",
                                "name": "客服1号部门",
                                "id": 9,
                                "text": "枣庄晟智-客服组-客服1号部门",
                                "sort": 1
                            },
                            {
                                "code": "KFZ0101",
                                "name": "客服2号部门",
                                "id": 10,
                                "text": "枣庄晟智-客服组-客服1号部门-客服2号部门",
                                "sort": 1
                            },
                            {
                                "code": "YYZX",
                                "name": "运营中心",
                                "id": 4,
                                "text": "枣庄晟智-运营中心",
                                "sort": 2
                            },
                            {
                                "code": "JSB02",
                                "name": "开发组",
                                "id": 6,
                                "text": "枣庄晟智-技术部-开发组",
                                "sort": 2
                            },
                            {
                                "code": "JSB03",
                                "name": "产品设计组",
                                "id": 7,
                                "text": "枣庄晟智-技术部-产品设计组",
                                "sort": 3
                            },
                            {
                                "code": "KFZ",
                                "name": "客服组",
                                "id": 8,
                                "text": "枣庄晟智-客服组",
                                "sort": 4
                            }
                        ],
                        "compareOptionsMulti": true,
                        "paramTypeId": 2,
                        "paramObj": {
                            "createdById": 0,
                            "createdByName": "系统",
                            "createdAt": "2022-02-22 14:10",
                            "lastUpdatedById": 0,
                            "lastUpdatedByName": "系统",
                            "lastUpdatedAt": "2022-02-22 14:10",
                            "deleted": false,
                            "id": 2,
                            "typeId": 1,
                            "typeName": "固定参数",
                            "paramTypeId": 2,
                            "paramTypeName": "字符",
                            "defCode": null,
                            "defName": null,
                            "paramName": "departId",
                            "paramKey": "提交人主部门",
                            "description": null
                        }
                    }
                ],
                "label": "提交人主部门 包含于 技术部",
                "expression": "'2'.contains(departId)",
                "previewStr": "提交人主部门 包含于 技术部"
            },
            "label": "提交人主部门 包含于…"
        },
        {
            "clazz": "flow",
            "source": "judge-node1657090432441",
            "target": "approval-node1657090342243",
            "sourceAnchor": 3,
            "targetAnchor": 1,
            "sourceType": "judge-node",
            "targetType": "approval-node",
            "shape": "flow-polyline-round",
            "style": {
                "stroke": "#BFC5D2",
                "lineWidth": 1,
                "lineAppendWidth": 10,
                "cursor": "pointer"
            },
            "startPoint": {
                "x": 435,
                "y": 135,
                "index": 3
            },
            "endPoint": {
                "x": 570,
                "y": 215,
                "index": 1
            },
            "type": "edge",
            "id": "edge8",
            "data": {
                "conditionData": [
                    {
                        "link": null,
                        "leftParenthesis": false,
                        "field": "departId",
                        "condition": "包含于",
                        "compareObj": [
                            4,
                            6
                        ],
                        "rightParenthesis": false,
                        "judgeCondition": null,
                        "compareOptions": [
                            {
                                "code": "default_org",
                                "name": "默认部门",
                                "id": -1,
                                "text": "默认部门",
                                "sort": 1
                            },
                            {
                                "code": "JSB",
                                "name": "技术部",
                                "id": 2,
                                "text": "枣庄晟智-技术部",
                                "sort": 1
                            },
                            {
                                "code": "JSB01",
                                "name": "测试部",
                                "id": 3,
                                "text": "枣庄晟智-技术部-测试部",
                                "sort": 1
                            },
                            {
                                "code": "YYZX01",
                                "name": "商务组",
                                "id": 5,
                                "text": "枣庄晟智-运营中心-商务组",
                                "sort": 1
                            },
                            {
                                "code": "KFZ01",
                                "name": "客服1号部门",
                                "id": 9,
                                "text": "枣庄晟智-客服组-客服1号部门",
                                "sort": 1
                            },
                            {
                                "code": "KFZ0101",
                                "name": "客服2号部门",
                                "id": 10,
                                "text": "枣庄晟智-客服组-客服1号部门-客服2号部门",
                                "sort": 1
                            },
                            {
                                "code": "YYZX",
                                "name": "运营中心",
                                "id": 4,
                                "text": "枣庄晟智-运营中心",
                                "sort": 2
                            },
                            {
                                "code": "JSB02",
                                "name": "开发组",
                                "id": 6,
                                "text": "枣庄晟智-技术部-开发组",
                                "sort": 2
                            },
                            {
                                "code": "JSB03",
                                "name": "产品设计组",
                                "id": 7,
                                "text": "枣庄晟智-技术部-产品设计组",
                                "sort": 3
                            },
                            {
                                "code": "KFZ",
                                "name": "客服组",
                                "id": 8,
                                "text": "枣庄晟智-客服组",
                                "sort": 4
                            }
                        ],
                        "compareOptionsMulti": true,
                        "paramTypeId": 2,
                        "paramObj": {
                            "createdById": 0,
                            "createdByName": "系统",
                            "createdAt": "2022-02-22 14:10",
                            "lastUpdatedById": 0,
                            "lastUpdatedByName": "系统",
                            "lastUpdatedAt": "2022-02-22 14:10",
                            "deleted": false,
                            "id": 2,
                            "typeId": 1,
                            "typeName": "固定参数",
                            "paramTypeId": 2,
                            "paramTypeName": "字符",
                            "defCode": null,
                            "defName": null,
                            "paramName": "departId",
                            "paramKey": "提交人主部门",
                            "description": null
                        }
                    },
                    {
                        "link": "and",
                        "leftParenthesis": false,
                        "field": "money",
                        "condition": "gt",
                        "compareObj": 50,
                        "paramObj": {
                            "createdById": 0,
                            "createdByName": "系统",
                            "createdAt": "2022-02-22 14:10",
                            "lastUpdatedById": 0,
                            "lastUpdatedByName": "系统",
                            "lastUpdatedAt": "2022-02-22 14:10",
                            "deleted": false,
                            "id": 19,
                            "typeId": 2,
                            "typeName": "对应各个流程参数",
                            "paramTypeId": 1,
                            "paramTypeName": "数值",
                            "defCode": "RCM_DRAWER_ADMITTANCE",
                            "defName": "开票人准入申请",
                            "paramName": "money",
                            "paramKey": "金额",
                            "description": ""
                        },
                        "rightParenthesis": false,
                        "judgeCondition": [
                            {
                                "value": "==",
                                "label": "等于"
                            },
                            {
                                "value": "!=",
                                "label": "不等于"
                            },
                            {
                                "value": "gt",
                                "label": "大于"
                            },
                            {
                                "value": "ge",
                                "label": "大于等于"
                            },
                            {
                                "value": "lt",
                                "label": "小于"
                            },
                            {
                                "value": "le",
                                "label": "小于等于"
                            }
                        ],
                        "compareOptions": null,
                        "compareOptionsMulti": false,
                        "paramTypeId": 1
                    }
                ],
                "label": "提交人主部门 包含于 运营中心、开发组 并且  金额 大于 50",
                "expression": "'4、6'.contains(departId) && money>50",
                "previewStr": "提交人主部门 包含于 运营中心、开发组 并且  金额 大于 50"
            },
            "label": "提交人主部门 包含于…"
        },
        {
            "clazz": "flow",
            "source": "start-node1657090334090",
            "target": "judge-node1657090432441",
            "sourceAnchor": 3,
            "targetAnchor": 1,
            "sourceType": "start-node",
            "targetType": "judge-node",
            "shape": "flow-polyline-round",
            "style": {
                "stroke": "#BFC5D2",
                "lineWidth": 1,
                "lineAppendWidth": 10,
                "cursor": "pointer"
            },
            "startPoint": {
                "x": 240,
                "y": 130,
                "index": 3
            },
            "endPoint": {
                "x": 295,
                "y": 135,
                "index": 1
            }
        },
        {
            "clazz": "flow",
            "source": "handle-node1657090345354",
            "target": "end-node1657090349283",
            "sourceAnchor": 2,
            "targetAnchor": 3,
            "sourceType": "handle-node",
            "targetType": "end-node",
            "shape": "flow-polyline-round",
            "style": {
                "stroke": "#BFC5D2",
                "lineWidth": 1,
                "lineAppendWidth": 10,
                "cursor": "pointer"
            },
            "startPoint": {
                "x": 930,
                "y": 185,
                "index": 2
            },
            "endPoint": {
                "x": 710,
                "y": 455,
                "index": 3
            }
        }
    ]
}
